export const Hospital = "hospital";
export const School = "school";
export const Police = "Police";
